import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss'],
})
export class StockComponent implements OnInit {
  constructor(public generalService: GeneralService) {}
  article;
  data = null;
  ngOnInit(): void {}
  searchArticle() {
    setTimeout(() => {
      this.generalService
        .rechercheTable('API_Art', this.article)
        .subscribe((res) => {
          this.data = res[0];
        });
    }, 200);
  }
}
